import Form from "../../gui/Form/Form"
import { useOverlay } from "../../gui/Overlay/OverlayProvider"
import { usePath } from "../../libs/path/PathProvider"
import PortUtils from "../../portlibs/PortUtils"
import { TAddHoldingProps } from "./TAddHoldingProps"
import DividendDlg from "./DividendDlg"
import CashDlg from "./CashDlg"
import EquityDlg from "./EquityDlg"
import usePortfolio from "../../hooks/PortfolioProvider"
import { CashTransaction } from "../../models/CashTrasanction"

export default function useAddHolding(){
    const {addOverlay,hasOverlay} = useOverlay()
    const {hash,setHash} = usePath()
    const {portfolio} = usePortfolio()

    const afterClosed = () => {
        const {holdingId} = PortUtils.parseHash(hash)
        setHash(PortUtils.createHash(holdingId))
    }
    const addHolding = (props:TAddHoldingProps) => {
        if (hasOverlay(PortUtils.AddHoldingId)) return
        const holding = props.holdingId ? portfolio.holding(props.holdingId) : null
        let dlg:React.ReactNode|undefined = undefined
        if (props.transaction) {
            if (props.transaction.isDividend) dlg = <DividendDlg {...props}/>
            else if (props.transaction instanceof CashTransaction) dlg = <CashDlg {...props}/>
        }
        if (!dlg && holding && holding.isCash) dlg = <CashDlg {...props}/>
        if (!dlg) dlg = <EquityDlg {...props}/>
        addOverlay(PortUtils.AddHoldingId, {
            children:<Form defaultValid={!!props.transaction}>{dlg}</Form>,
            className:"dialog popup",
            afterClosed
        })
    }
    return {addHolding}
}